import { Component, ReactNode } from 'react';
import { m } from 'framer-motion';
import * as hashLocalStorage from '../utils/hashLocalStorage';
import { styled } from '@mui/material/styles';
// @mui
import { Button, Typography, Container } from '@mui/material';
// components
import Page from './Page';
import { MotionContainer, varBounce } from './animate';
// assets
import { SeverErrorIllustration } from '../assets/icons';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: any;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error: error };
  }

  public componentDidCatch(error: Error) {
    this.setState({ error });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Page title='Internal Server Error'>
          <Container component={MotionContainer}>
            <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
              <m.div variants={varBounce().in}>
                <Typography variant='h3' paragraph>
                  Internal Server Error
                </Typography>
              </m.div>

              <m.div variants={varBounce().in}>
                <Typography sx={{ color: 'text.secondary' }}>{`${this.state.error}`}</Typography>
              </m.div>

              <m.div variants={varBounce().in}>
                <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
              </m.div>

              <Button
                size='large'
                variant='contained'
                onClick={() => {
                  hashLocalStorage.clear();
                  window.location.reload();
                }}
              >
                Go to Home
              </Button>
            </ContentStyle>
          </Container>
        </Page>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
